import React from 'react';
import AdminLayoutWrapper from '../../components/layout/AdminLayoutWrapper';
import ReferralContent from '../../components/referral/ReferralContent';



const AdminReferralPage = () => {
  return (
    <AdminLayoutWrapper>
      <ReferralContent isChampions={false} />
    </AdminLayoutWrapper>
  );
};

export default AdminReferralPage;
